module.exports = __webpack_public_path__ + "img/49.2a669b1.jpg";